<section
  class="
    ui
    placeholder
    fitted
    horizontally
    section-padding
    trending-screens-container
    very
    padded
    segment
    m-0
  "
>
  <div class="ui placeholder fitted segment">
    <div class="ui container p-relative">
      <div>
        <h1 class="ui header">Trending Screens</h1>
      </div>
      <div
        class="ui basic padded horizontally fitted segment"
        style="position: unset"
      >
        <div
          class="swiper-container section-topside-nav"
          [swiper]="listingconfig"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              *ngFor="let trendingScreen of trendingScreens"
            >
              <signgaze-screen-listing-item
                [isTrendingActive]="isTrendingScreen"
                [screenId]="trendingScreen.hit"
              ></signgaze-screen-listing-item>
            </div>
          </div>
          <div class="swiper-button-prev screen-list-prev pure-hidden-xs"></div>
          <div class="swiper-button-next screen-list-next pure-hidden-xs"></div>
        </div>
      </div>
    </div>
  </div>
</section>
